import React from "react";
import { Icon } from "@iconify/react";

const WidgetsIcon = () => (
  <Icon icon="lucide:layout-template" width={18} height={18} />
);

export default WidgetsIcon;
